<script setup lang="ts">
  import { Card } from "@/components/ui/card"
  import { Skeleton } from "@/components/ui/skeleton"
</script>

<template>
  <Card
    class="flex w-full flex-col border-primary-400 bg-primary-300 p-4 sm:flex-row sm:p-6 md:min-h-[286px] md:flex-col"
    data-testid="user-info-card-skeleton"
  >
    <div class="flex-grow justify-center">
      <Skeleton class="hidden h-[56px] w-[135px] sm:block md:h-[72px]" />
    </div>
    <div class="flex flex-col">
      <Skeleton class="h-[24px] w-[250px] md:h-[28px]" />
      <Skeleton class="mt-1 h-[24px] w-[200px] md:h-[28px]" />
    </div>
  </Card>
</template>
